"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.externalLinkScroll = exports.showHideBackToTop = exports.scroll = void 0;
/* ========================================================================
    Module: Scroll
 ========================================================================== */
const uikit_1 = __importDefault(require("uikit"));
const util_1 = require("~modules/util");
const headerHeightSmall = (0, util_1.getCssPropertyValue)("--project-header-height-s");
const headerHeightMedium = (0, util_1.getCssPropertyValue)("--project-header-height-m");
/**
 * スクロールを設定する
 *
 * @returns void
 */
const scroll = () => {
    const scrollSelector = ".js-scroll";
    const breakPointMedium = uikit_1.default.util.getCssVar("breakpoint-l");
    const options = {
        offset: parseInt(headerHeightSmall),
    };
    if (window.matchMedia(`(min-width: ${breakPointMedium})`).matches) {
        options.offset = parseInt(headerHeightMedium);
    }
    uikit_1.default.scroll(scrollSelector, options);
};
exports.scroll = scroll;
/**
 * Show / hide back to top
 *
 * @returns void
 */
const showHideBackToTop = () => {
    const isViewportMedium = window.matchMedia(`(min-width: ${uikit_1.default.util.getCssVar("breakpoint-m")})`).matches;
    const baseBottomSmall = (0, util_1.getCssPropertyValue)("--project-back-to-top-base-bottom-s");
    const baseBottomMedium = (0, util_1.getCssPropertyValue)("--project-back-to-top-base-bottom-m");
    const scrollEndBottomSmall = (0, util_1.getCssPropertyValue)("--project-back-to-top-scroll-end-bottom-s");
    const scrollEndBottomMedium = (0, util_1.getCssPropertyValue)("--project-back-to-top-scroll-end-bottom-m");
    const scrollTop = document.documentElement.scrollTop;
    const scrollBottom = scrollTop + window.innerHeight;
    const scrolledClass = "is-scrolled";
    const backToTopElement = document.querySelector(".js-back-to-top");
    if (backToTopElement) {
        if (scrollTop > 100) {
            backToTopElement.classList.add(scrolledClass);
            backToTopElement.setAttribute("aria-hidden", "false");
        }
        else {
            backToTopElement.classList.remove(scrolledClass);
            backToTopElement.setAttribute("aria-hidden", "true");
        }
        let baseBottom = parseInt(baseBottomSmall);
        if (isViewportMedium) {
            baseBottom = parseInt(baseBottomMedium);
        }
        backToTopElement.style.position = "fixed";
        backToTopElement.style.bottom = baseBottom + "px";
        let baseOffset = parseInt(scrollEndBottomSmall);
        if (isViewportMedium) {
            baseOffset = parseInt(scrollEndBottomMedium);
        }
        const documentHeight = document.documentElement.offsetHeight;
        const fixedPos = scrollBottom + baseOffset;
        if (documentHeight < fixedPos) {
            backToTopElement.style.position = "absolute";
            backToTopElement.style.bottom = baseOffset + "px";
        }
    }
};
exports.showHideBackToTop = showHideBackToTop;
/**
 * In-page link scrolling from external links
 *
 * @returns void
 */
const externalLinkScroll = () => {
    const isViewportMedium = window.matchMedia(`(min-width: ${uikit_1.default.util.getCssVar("breakpoint-m")})`).matches;
    const fragment = location.hash;
    let headerHeight = parseInt(headerHeightSmall);
    if (isViewportMedium) {
        headerHeight = parseInt(headerHeightMedium);
    }
    if (fragment && headerHeight) {
        const target = document.querySelector(fragment);
        if (target) {
            const targetOffsetTop = target.offsetTop;
            document.documentElement.scrollTop = targetOffsetTop;
            setTimeout(() => {
                document.documentElement.scrollTop = targetOffsetTop - headerHeight;
            }, 200);
        }
    }
};
exports.externalLinkScroll = externalLinkScroll;
